<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { CopilotStepStatusEnum } from "~/utils/enums/copilot/workflow.enums";
import type { ICopilotAnalysis } from "~/utils/interfaces/copilot-blocks-interfaces";

defineProps<{
  analysis: ICopilotAnalysis;
}>();
</script>

<template>
  <div class="flex flex-col gap-px">
    <span class="body_demi pb-[6px] pl-2 leading-5 text-primary-color">{{ analysis.title }}</span>

    <ul class="flex flex-col gap-px">
      <li
        v-for="(step, index) of analysis.steps"
        :key="index"
        class="flex items-center gap-[9px] rounded-md px-2 py-1.5"
        :class="step.status === CopilotStepStatusEnum.RUNNING ? 'bg-light-blue-color' : null"
      >
        <SvgIcon
          v-if="step.status === CopilotStepStatusEnum.DONE"
          name="tick"
          class="h-[14px] w-[14px] shrink-0 text-primary-blue-color"
        />
        <SvgIcon
          v-else-if="step.status === CopilotStepStatusEnum.RUNNING"
          name="spinner"
          class="h-[14px] w-[14px] shrink-0 animate-spin text-primary-blue-color"
        />
        <SvgIcon
          v-else-if="step.status === CopilotStepStatusEnum.ERROR"
          name="warning_error"
          class="h-[14px] w-[14px] shrink-0 text-primary-red-color"
        />
        <span v-else class="flex h-[14px] w-[14px] shrink-0 items-center justify-center">
          <span class="h-[6px] w-[6px] rounded-full bg-stroke-grey-color"></span>
        </span>

        <span
          class="leading-[18px]"
          :class="
            step.status === CopilotStepStatusEnum.PENDING
              ? 'meta_regular text-grey-medium-color'
              : step.status === CopilotStepStatusEnum.RUNNING
                ? 'meta_med text-primary-color'
                : step.status === CopilotStepStatusEnum.ERROR
                  ? 'meta_regular text-primary-red-color'
                  : 'meta_regular text-secondary-color'
          "
          >{{ step.label }}</span
        >
      </li>
    </ul>
  </div>
</template>
